import React from 'react'
import { Container } from '@mui/material'
import { FlatPageFragment } from '@graphql/fragments/__generated__/FlatPage.generated'
import Loader from '@components/Loader'
import { Trans, useTranslation } from 'react-i18next'
import { SITE_NAME } from '../../../../constants'
import WholesaleRegistrationForm from '../Registration/WholesaleRegistrationForm'

interface Props {
  page: FlatPageFragment | null
  isLoading: boolean
}

const Page: React.FC<Props> = ({ page, isLoading }) => {
  const { t } = useTranslation()
  return (
    <div style={{ backgroundColor: '#f2eeea' }}>
      <div className='md:py-20'>
        <Container className='bg-white rounded-2xl' maxWidth='lg'>
          <div className='px-0 md:px-60 lg:px-160 py-30'>
            {!page && !isLoading && (
              <h3 className='text-center font-bold uppercase'>
                {t('wholesale.appCreated', 'Thank you for application!')}
              </h3>
            )}
            {!page && isLoading && (
              <Loader className='spinner global' type='ThreeDots' color='#333' height={100} width={100} visible />
            )}
            {page && (
              <>
                <h2 className='my-30 uppercase font-semibold text-3xl text-center leading-normal'>{page.title}</h2>
                <div className='mt-20 mb-100' dangerouslySetInnerHTML={{ __html: page.content }} />
              </>
            )}
          </div>
        </Container>
      </div>
    </div>
  )
}

export default Page
